(function() {
  const fixCurrency = (str) => {
    if (!str) return str;

    let cleaned = String(str)
      .replace(/[\u00A0\u202F\u2007\u2009]/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();

    const currencies = ['$', '€', '£', '¥'];
    const last = cleaned.slice(-1);

    if (currencies.includes(last)) {
      const amount = cleaned.slice(0, -1).trim();
      return `${last}${amount}`;
    }

    return cleaned;
  };

  const updateAllCPBPrices = () => {
    const selector = [
      '[data-testid="multycurrency-price"]',
      '.cpb-custom-price',
      '.cpb-selected-choice-title',
      '.cpb-summary-price'
    ].join(', ');

    document.querySelectorAll(selector).forEach(el => {
      const fixed = fixCurrency(el.textContent);
      if (el.textContent !== fixed) el.textContent = fixed;
    });
  };

  const addCustomPrice = () => {
    const productTitle = document.querySelector('.cpb-product-title')
    const cpbPrice = document.querySelector('[data-testid="multycurrency-price"]')
    if (!productTitle || !cpbPrice) return;

    const customPrice = document.createElement('div');
    customPrice.classList.add('cpb-custom-price');

    customPrice.textContent = fixCurrency(cpbPrice.textContent);

    cpbPrice.style.display = 'none';

    productTitle.insertAdjacentElement('afterend', customPrice);

    const observer = new MutationObserver(() => {
      customPrice.textContent = fixCurrency(cpbPrice.textContent);
    });

    observer.observe(cpbPrice, {
      childList: true,
      characterData: true,
      subtree: true
    });
  };

  const selectedChoiceTitle = () => {
    const imgCategories = document.querySelectorAll('.cpb-category-img');
    const Panels = CPB.getStore().getState().Product.panels;
    const Layers = CPB.getStore().getState().Product.layers;

    imgCategories.forEach(category => {
      const categoryTitle = category.querySelector('.cpb-category-title');
      const categoryId = category.dataset.categoryId;

      const layer = Layers.find(layer => layer.category === categoryId);
      if (!layer) return;

      const panel = Panels.find(panel => panel.id === layer.panel);
      const cat = panel.categories.find(cat => cat.id === layer.category);
      const option = cat.options.find(opt => opt.id === layer.option);
      if (!option) return;

      const priceFormatted = fixCurrency(`${option.price}$`);

      const exists = category.querySelector('.cpb-selected-choice-title');
      if (exists) {
        exists.textContent = `${option.option.data.label} ${priceFormatted}`;
      } else {
        const selectedChoice = document.createElement('div');
        selectedChoice.classList.add('cpb-selected-choice-title');
        selectedChoice.textContent = `${option.option.data.label} ${priceFormatted}`;
        categoryTitle.append(selectedChoice);
      }
    });
  };

  document.body.addEventListener('CPB_ON_OPTIONS_UPDATE', function() {
    selectedChoiceTitle();
    updateAllCPBPrices();
  });
  document.body.addEventListener('CPB_ON_UPDATE_CURRENT_TAB', function() {
    selectedChoiceTitle();
    updateAllCPBPrices();
  });

  document.body.addEventListener('CPB_ON_PRODUCT_MOUNTED', function() {
    addCustomPrice();
    updateAllCPBPrices();

    if (window.innerWidth < 999) {
      const previewContainer = document.querySelector('.cpb-preview-container');
      const panelContainer = document.querySelector('.cpb-panels-container');
      const previewLayers = document.querySelector('.cpb-preview-layers');

      setTimeout(() => {
        panelContainer.style.setProperty("--padding", `${previewContainer.clientHeight + 20}px`);
        previewLayers.style.setProperty("--padding", `${previewContainer.clientHeight - 40}px`);
      }, 500);
    }
  });

})();
